/***************************************************************************

    NavCommonComponent.tsx
    -------------------------
    last Update          : August 26, 2025
    by                   : quentin.savoye@cil4sys.com
    copyright            : (C) 2025 by CIL4Sys Engineering 

***************************************************************************/


import { Link } from "gatsby-plugin-react-i18next"
import { Dropdown, Nav } from "react-bootstrap"
import React from "react"

import { NavbarItemType } from "../../../types/types"

interface Props {
	language: string
	data: Array<NavbarItemType>
	variant: "top" | "middle" | "bottom"
}

export class NavCommonComponent extends React.Component<Props> {
	constructor(aProps: Props) {
		super(aProps)
	}

	public override render(): React.ReactNode {
		return (
			<Nav>
				{this.props.data
					.sort((a, aB) => (a.rank > aB.rank ? 1 : -1))
					.map((aNode) => {
						if (aNode.navlinks.length == 0 && aNode.externalLink != undefined) {
							return (
								<Nav.Link
									className={"navlink-" + this.props.variant + " nav-link"}
									key={aNode.title}
									language={this.props.language}
									href={aNode.externalLink}>
									{aNode.title}
								</Nav.Link>
							)
						} else if (aNode.navlinks.length == 0) {
							return (
								// eslint-disable-next-line @typescript-eslint/ban-ts-comment
								//@ts-ignore
								<Link
									className={"navlink-" + this.props.variant + " nav-link"}
									key={aNode.title}
									language={this.props.language}
									to={"/" + aNode.page?.name}>
									{aNode.title}
								</Link>
							)
						} else {
							return (
								<Dropdown
									className={"nav-dropdown-" + this.props.variant}
									key={aNode.title}
									as={Nav.Item}
									onToggle={(isOpen: boolean) => {
										if (this.props.variant !== "middle") return
										if (typeof window === "undefined" || window.innerWidth <= 992) return
										setTimeout(() => {
											const container = document.querySelector(".navbar-expand-lg .navbar-collapse.justify-content-end:not(.nave-bar-collapse-top)")?.closest(".nav-bar-container") as HTMLElement | null
											if (!container) return
											const openMenu = container.querySelector(".nav-dropdown-middle.show .dropdown-menu") as HTMLElement | null
											container.style.paddingBottom = openMenu ? openMenu.offsetHeight + "px" : ""
										}, 0)
									}}
								>
									<Dropdown.Toggle as={Nav.Link}>
										<span className="myMenu">{aNode.title}</span>
									</Dropdown.Toggle>
									<Dropdown.Menu align="end">
										{aNode.navlinks
											.sort((a, aB) => (a.rank > aB.rank ? 1 : -1))
											.map((aNavlink) => (
												<Dropdown.Item as={Link} key={aNavlink.link} language={this.props.language} to={"/" + aNode.page?.name + "#" + aNavlink.link}>
													<span className="myMenuItem"> {aNavlink.text} </span>
												</Dropdown.Item>
											))}
									</Dropdown.Menu>
								</Dropdown>
							)
						}
					})}
			</Nav>
		)
	}
}
